(function AllInclusivePropertiesListing($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('AllInclusiveProperties/landing', function onload()
		{
			$('#ais-vendor-list').slick({
				slidesToShow  : 4,
				arrows        : true,
				slidesToScroll: 1,
				autoplay      : true,
				autoplaySpeed : 2000,
				responsive    : [
					{
						breakpoint: 992,
						settings  : {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 830,
						settings  : {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 768,
						settings  : {
							slidesToShow: 1,
						}
					}
				]
			});
		});
	});
}(jQuery, window.Adzuki || {}));
